import { bookingApiUrl, supabase } from './supabase'
export async function messagingRequest<T>(body:Record<string,unknown>):Promise<T> {
  const {data}=await supabase.auth.getSession()
  if(!data.session) throw new Error('Sign in to the admin again.')
  const response=await fetch(bookingApiUrl.replace(/booking-api$/,'admin-messaging'),{method:'POST',headers:{Authorization:`Bearer ${data.session.access_token}`,'Content-Type':'application/json',apikey:import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY},body:JSON.stringify(body)})
  const result=await response.json().catch(()=>null)
  if(!response.ok) throw new Error(result?.error||'Messaging is unavailable. Refresh the history before trying again.')
  return result as T
}
